import { createApiClient } from '@/api/apiClient';
import { DM_API_BASE_URL } from '@/constants';
import { GetAiresFilesEmpty } from '@/types';

export const dataManagementService = createApiClient({
  baseURL: `${DM_API_BASE_URL}/api/datamanagement`,
});

export const getAiresFilesEmpty = async () => {
  const { data } =
    await dataManagementService.get<GetAiresFilesEmpty>('/airesfilesisempty');

  return data.result.isEmpty;
};
